import { apiBaseUrl } from 'app/src/msw/shopping/staticapi/apiBaseUrl'
import { http, HttpResponse } from 'msw'

export const startOrder = http.post<{ orderId: string }, object, undefined>(
  apiBaseUrl + '/orders/:orderId/start',
  async ({ params }) => {
    const orderId = params.orderId

    if (orderId === 'FAILED') {
      return HttpResponse.json(
        {
          status: 409,
          type: 'urn:CreditInsufficient:UserMessage',
          title: "Attenzione, valore fringe benefit non disponibile per procedere con l'operazione",
          rc: 40903,
        },
        { status: 409 },
      )
    }

    return HttpResponse.text(undefined, { status: 204 })
  },
)
